import { useState } from "react";
import { Link } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { eur, img, LINES } from "@/lib/api";

export const ProductCard = ({ p, highlight }) => {
  const { add } = useCart();
  const [fmt, setFmt] = useState(p.formats[0]);
  return (
    <div className="group bg-white border border-slate-200 hover:border-[#93C5FD] rounded flex flex-col transition-[border-color,box-shadow,transform] duration-300 hover:shadow-[0_18px_40px_-20px_rgba(11,29,58,0.35)] hover:-translate-y-1"
      data-testid={`product-card-${p.slug}`}>
      <Link to={`/producto/${p.slug}`} className="relative block bg-gradient-to-b from-[#EFF6FF] to-white aspect-square overflow-hidden rounded-t">
        <span className="absolute top-3 left-3 z-10 text-[10px] font-bold tracking-wider uppercase bg-[#0B1D3A] text-white px-2 py-1 rounded-sm">
          {LINES[p.line]}
        </span>
        <img src={img(p.images?.[0])} alt={p.name} loading="lazy" className="w-full h-full object-contain p-6 mix-blend-multiply transition-transform duration-500 group-hover:scale-105" />
      </Link>
      <div className="p-4 flex flex-col flex-1">
        <Link to={`/producto/${p.slug}`} className="font-display text-xl font-extrabold text-[#0B1D3A] leading-tight hover:text-[#DC2626] transition-colors" data-testid={`product-card-name-${p.slug}`}>
          {p.name.replace("FAUNNY ", "")}
        </Link>
        <p className="text-sm text-slate-600 mt-1.5 line-clamp-2">{highlight || p.short}</p>
        <div className="flex flex-wrap gap-1.5 mt-3">
          {p.bundle && <span className="text-xs font-bold bg-[#DC2626] text-white px-2.5 py-1 rounded-full">Pack regalo -{p.bundle_pct} %</span>}
          {!p.bundle && p.formats.map((f) => (
            <button key={f.id} onClick={() => setFmt(f)} data-testid={`card-format-${p.slug}-${f.id}`}
              className={`text-xs px-2.5 py-1 rounded-full border transition-colors ${fmt.id === f.id ? "bg-[#0B1D3A] text-white border-[#0B1D3A]" : "border-slate-300 text-slate-700 hover:border-[#2563EB]"}`}>
              {f.label}
            </button>
          ))}
        </div>
        <div className="mt-auto pt-4 flex items-center justify-between gap-2">
          <span className="text-xl font-extrabold text-[#DC2626]" data-testid={`product-card-price-${p.slug}`}>{eur(fmt.price)}{p.compare_price > fmt.price && <span className="ml-2 text-sm font-semibold text-slate-400 line-through">{eur(p.compare_price)}</span>}</span>
          {p.bundle ? (
            <Link to={`/producto/${p.slug}`} data-testid={`add-to-cart-${p.slug}`} className="bg-[#DC2626] hover:bg-[#B91C1C] text-white text-sm font-bold px-4 py-2.5 rounded-full transition-colors">Elegir tallas</Link>
          ) : (
          <button onClick={() => add(p, fmt)} data-testid={`add-to-cart-${p.slug}`}
            className="flex items-center gap-1.5 bg-[#DC2626] hover:bg-[#B91C1C] disabled:bg-slate-300 text-white text-sm font-bold px-4 py-2.5 rounded-full transition-colors">
            <ShoppingBag size={15} /> Añadir
          </button>
          )}
        </div>
      </div>
    </div>
  );
};
